import { createSlice } from "@reduxjs/toolkit";

// Detalle 1 de la puntuacion: los valores de la escala
// (puntuaciondetalle).
const initialState = {
    defaultEntity: [{
        id: 0,
        numero: 0,
        idPuntuacion: 0,
        valor: 0,
        texto: "",
        descripcion: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    }],
    entity: [{
        id: 0,
        numero: 0,
        idPuntuacion: 0,
        valor: 0,
        texto: "",
        descripcion: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    }],
    validationActive: {
        AtLeastOneRow: false,
    },
    validationMessage: [],
}

export const puntuacionDetalleSlice = createSlice({
    name: "puntuacionDetalle",
    initialState,
    reducers: {
        setEntity: (state, action) => {
            state.entity = action.payload;
        },
        setData: (state, action) => {
            var { numero, name, value } = action.payload;

            // parseInt de una cadena vacia da NaN, y NaN se manda como null
            // en el JSON: la API lo rechaza. Un valor vacio es 0.
            if (name.startsWith("id") || name.startsWith("valor")) {
                value = parseInt(value)

                if (isNaN(value)) value = 0
            }

            const index = state.entity.findIndex(item => item.numero === numero);
            state.entity[index][name] = value;

            Object.keys(state.validationActive).forEach(function (key) {
                state.validationActive[key] = true;
            })
        },
        add: (state, action) => {
            var idPuntuacion = action.payload;

            var maxNumero = state.entity.length === 0 ? 0 : Math.max.apply(null, state.entity.map((item) => { return item.numero; }))

            state.entity.push({
                ...state.defaultEntity[0],
                numero: maxNumero + 1,
                idPuntuacion: idPuntuacion,
            });
        },
        remove: (state, action) => {
            state.entity = state.entity.filter(item => item.numero !== action.payload)
        },
        setValidations: (state, action) => {
            state.validationMessage = action.payload;
        },
        activeValidations: (state, action) => {
            Object.keys(state.validationActive).forEach(function (key) {
                state.validationActive[key] = true;
            })
        },
    },
});

export const { setEntity, setData, add, remove
    , setValidations, activeValidations } = puntuacionDetalleSlice.actions;
export default puntuacionDetalleSlice.reducer;